import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-center"
  }, [_c(VDialog, {
    attrs: {
      persistent: "",
      "max-width": "600"
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "dialog-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c("div", {
    staticClass: "dialog-fa"
  }, [_c("i", {
    staticClass: "fas fa-exclamation-circle"
  })]), _c(VCardText, [_vm._v(_vm._s(_vm.text))]), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.redirect
    }
  }, [_vm._v("Go back to the detail")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };